import { useCallback, useState } from "react";
import { AuthApi } from "../../infrastructure/api/AuthApi";
import { SessionManager } from "../../infrastructure/session/SessionManager";
import { setupPassword } from "../useCases/setupPassword";
import type { PasswordDTO } from "../../domain/dto/PasswordDTO";
import type { EnableTotp } from "../../domain/entities/EnableTotp";

export const usePassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setPassword = useCallback(async (data: PasswordDTO): Promise<EnableTotp> => {
    setLoading(true);
    setError(null);
    try {
      const repo = new AuthApi();
      const sessionPort = new SessionManager();
      return await setupPassword(repo, sessionPort, data);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const resetPassword = useCallback(async (data: PasswordDTO, tempAccessToken: string): Promise<EnableTotp> => {
    setLoading(true);
    setError(null);
    try {
      const repo = new AuthApi();
      return await repo.resetPassword(data, tempAccessToken);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { setPassword, resetPassword, loading, error };
};